module.exports = __webpack_public_path__ + "static/media/Logo-04.77f548c9.jpg";